export var BaseDict = {
    PlaceBets: "Place Your Bet",
    Danger: "Suspended",
    RetainSelections: "Retain Selections",
    AcceptOdds: "Accept New Odds",
    AcceptStake: "Accept New Stake",
    AcceptAll: "Accept Odds & Stake",
    //it's added BetsAccepted not BetAccepted because the second one contains "ticket" word
    BetsAccepted: "Your bet was accepted",
    KeepSelections: "Keep Selections",
    Clear: "Clear all",
    EmtyMsg: "Choose Your Selections",
    SelectionLabel: "Selections",
    Return: "Return",
    TicketNumber: "Ticket Number",
    Stake: "Stake",
    OddsChanged: "Odds changed",
    StakeChanged: "Stake changed"
};
//# sourceMappingURL=dict.js.map